import { styled } from '@mui/material';

const StyGridHeader = styled('div', {
    name: 'StyGridHeader',
})({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    padding: '12px 6px 12px 6px',
    backgroundColor: 'white',
    borderTopLeftRadius: '4px',
    borderTopRightRadius: '4px',
});

export default StyGridHeader;
